import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["deleteButton", "checkbox", "selectAll"];

  connect() {
    this.updateHiddenField(); // Initialize hidden field on page load
  }

  toggleSelectAll(event) {
    const isChecked = event.target.checked;
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = isChecked;
    });
    this.updateHiddenField();
    this.toggleDeleteButton();
  }

  toggleDeleteButton() {
    const hasChecked = this.checkboxTargets.some((checkbox) => checkbox.checked);
    this.deleteButtonTarget.disabled = !hasChecked;
  }

  updateHiddenField() {
    const selectedIds = this.checkboxTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);
    document.getElementById("hidden-document-ids").value = selectedIds.join(",");
  }
}
